import { aClient, useAtomValue } from '~/atoms'
import { Separator } from '~/components/ui'
import { PROPERTY_TYPES_COLORS } from '~/constants'
import { cn } from '~/lib'

export default function MapLegend({ className }: { className?: string }) {
  const client = useAtomValue(aClient)

  return (
    <div
      id="map-legend"
      className="absolute bottom-2 right-2 space-y-1 rounded-md bg-background px-2 py-1.5 text-xs shadow-md sm:bottom-6 sm:right-4">
      {client!.featured && client!.featured.length > 0 && (
        <div className="-ml-0.5 flex items-center gap-2">
          <svg
            className="h-4 w-4 fill-yellow-300 stroke-yellow-300"
            viewBox="0 0 248 236">
            <path
              d="M124,27.1146175 L154.237255,88.3819886 L221.849813,98.2066683 L172.924907,145.896666 L184.47451,213.236023 L124,181.442691 L63.5254895,213.236023 L75.0750933,145.896666 L26.1501866,98.2066683 L93.7627448,88.3819886 L124,27.1146175 Z"
              strokeWidth="24"
            />
          </svg>
          <span className="-ml-0.5 text-xs">Featured</span>
        </div>
      )}
      <div className="flex items-center gap-2">
        <span className="legend-triangle" />
        <span className="text-xs">Sale</span>
      </div>
      <div className="flex items-center gap-2">
        <span className="h-3 w-3 rounded-full bg-[#c026d3]"></span>
        <span className="text-xs">Lease</span>
      </div>
      <div className="flex items-center gap-2">
        <span className="h-3 w-3 bg-[#4338ca]"></span> Sale/Lease
      </div>
      <Separator className="!my-2" />
      {PROPERTY_TYPES_COLORS.map(({ propertyType, className }, index) => {
        return (
          <div key={index} className="flex items-center gap-2">
            <span className={cn('h-3 w-3 rounded-full', className)}></span>
            <span className="text-xs">{propertyType}</span>
          </div>
        )
      })}
    </div>
  )
}
